// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"9e81cd82","592":"534f3ea5"}[chunkId] + ".chunk.js";
};